import { IconButton, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { faShare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Tippy from '@/components/UI/Tippy'

import ShareMenuGroup from './ShareMenuGroup'

export default function ShareIconButton({
  url,
  description,
  shortDescription,
  tooltipText,
  square = false,
}: {
  url: string
  description: string
  shortDescription: string
  tooltipText: string
  square?: boolean
}): React.ReactElement | null {
  return (
    <Menu variant="normal" closeOnSelect={false} placement="bottom-end">
      <Tippy content={tooltipText}>
        <MenuButton
          as={IconButton}
          cursor="pointer"
          isRound={!square}
          variant="icon"
          aria-label="See options"
          icon={<FontAwesomeIcon icon={faShare} />}
        />
      </Tippy>
      <MenuList>
        <ShareMenuGroup url={url} description={description} shortDescription={shortDescription} />
      </MenuList>
    </Menu>
  )
}
